import BlogDetailsContainer from "../../../../Components/Miscellaneous/Blog/BlogDetails/BlogDetailsContainer";

const BlogDetails = () => {
  return <BlogDetailsContainer />;
};

export default BlogDetails;
